import { useCallback, useState } from 'react';

import ErrorResponse from '../types/ErrorResponse';
import ItemResponse from '../types/ItemResponse';

const defaultData = null!;
const defaultError = { errors: [] };

const useListQuery = <T>(
	fetcher: (
		dataSetter: (data: ItemResponse<T>) => void,
		errorSetter: (error: ErrorResponse) => void,
		...args: any
	) => Promise<void>,
) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isFetched, setIsFetched] = useState(false);
	const [isHasErrors, setIsHasErrors] = useState(false);
	const [error, setError] = useState<ErrorResponse>(defaultError);
	const [data, setData] = useState<ItemResponse<T>>(defaultData);

	const fetch = async (...args: any) => {
		setIsLoading(true);

		setData(defaultData);
		setError(defaultError);
		setIsHasErrors(false);

		await fetcher(
			(data) => {
				setData(data);
			},
			(error) => {
				setIsHasErrors(true);
				setError(error);
			},
			...args,
		);

		setIsLoading(false);
		setIsFetched(true);
	};

	return {
		isLoading,
		isFetched,
		isHasErrors,
		error,
		data,
		fetch: useCallback(fetch, []),
	};
};

export default useListQuery;
